import Container, { ContainerProps } from '@mui/material/Container';

type KmxContainerProps = Pick<ContainerProps, 'id' | 'maxWidth' | 'children' | 'sx' | 'className' | 'component'>;

export const KmxContainer = ({ id, maxWidth = 'md', children, sx, className, component }: KmxContainerProps) => (
    <Container
        id={id}
        maxWidth={maxWidth}
        className={className}
        component={component ?? 'div'}
        disableGutters
        sx={[
            {
                px: { xs: 3, sm: 5, md: 8 },
            },
            ...(Array.isArray(sx) ? sx : [sx]),
        ]}
    >
        {children}
    </Container>
);
